import React from 'react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
import { PackagePricing } from '../components/PackagePricing';
import { FeatureItem } from '../components/FeatureItem';
import { RelatedLinks } from '../components/RelatedLinks';
import { packages } from '../data/packages';
const pkg = packages.find(p => p.slug === 'wash-wax')!;
const faqs = [{
  question: 'How much does a Wash & Wax cost?',
  answer: 'A Wash & Wax is $160 for small and mid-size vehicles and $180 for SUVs and crossovers. A limited-time $20 off the listed price is currently available.'
}, {
  question: 'What is included in a Wash & Wax?',
  answer: 'An exterior wash, window cleaning, vacuum, a light interior wipe-down, tire dressing, and a hybrid ceramic spray.'
}, {
  question: 'Is the hybrid ceramic spray the same as a ceramic coating?',
  answer: "No. Mike's Pro Detail offers hybrid ceramic spray, a sprayed-on protective product — not a professional ceramic coating."
}, {
  question: 'Do you come to my home or office?',
  answer: 'Yes. We bring our own water and detailing equipment to your home or office anywhere in Ventura County. We require access to a standard electrical outlet at the service location.'
}];
export function WashWaxPage() {
  return <ServicePageLayout title="Wash & Wax" subtitle="A Wash and Wax cleans your car, adds a protective layer, helps paint stay shiny, repel water, and dirt." metaDescription="Mobile Wash & Wax in Ventura County — exterior wash, vacuum, windows, tire dressing and hybrid ceramic spray. $160 SM/Mid, $180 SUV. $20 off now. Call or text 818-381-9905." schema={{
    '@type': 'Service',
    name: 'Wash & Wax',
    serviceType: 'Mobile Car Wash and Wax',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail"
    },
    areaServed: ['Ventura County', 'Camarillo', 'Oxnard', 'Ventura', 'Thousand Oaks'],
    description: pkg.summary,
    offers: [{
      '@type': 'Offer',
      price: '160',
      priceCurrency: 'USD',
      description: 'Small / mid-size vehicle'
    }, {
      '@type': 'Offer',
      price: '180',
      priceCurrency: 'USD',
      description: 'SUV / crossover'
    }]
  }} faqs={faqs} breadcrumbs={[{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/services'
  }, {
    name: 'Wash & Wax',
    item: 'https://www.fulldetailpro.com/wash-wax'
  }]} data-id="element-1248" data-mp="3b6imoab3arnh">
      <p data-id="element-1249" data-mp="12r2amlssz4hl">
        Our <strong data-id="element-1250" data-mp="12qit3672ei43">Wash & Wax</strong> is the step up from a basic wash: a
        thorough clean inside and out, finished with a{' '}
        <Link to="/services/hybrid-ceramic-spray" data-id="element-1251" data-mp="xz13feahs3yf">hybrid ceramic spray</Link>{' '}
        that leaves a protective, glossy layer on your paint — performed at your
        home or office anywhere in Ventura County.
      </p>

      <PackagePricing pkg={pkg} data-id="element-1252" data-mp="1qhy2fix9dzou" />

      <figure className="not-prose my-10" data-id="element-1253" data-mp="1lq6hbnwvgm63">
        <img src="https://cdn.magicpatterns.com/uploads/bNVZWuDfAH9gZxv5SBhs7n/Blue_BMW_SUV.jpg" alt="Blue BMW SUV after a mobile exterior wash with hybrid ceramic spray" loading="lazy" decoding="async" className="w-full h-auto rounded-xl border border-zinc-800" data-id="element-1254" data-mp="1lp4xatxvopc8" />
      </figure>

      <h2 data-id="element-1255" data-mp="22y7fjgf56p1u">Benefits of a Wash & Wax</h2>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-1256" data-mp="231brizyump32">
        <FeatureItem data-id="element-1257" data-mp="27ylod0oki30x">
          <strong data-id="element-1258" data-mp="27z4znyjppt5z">Clean inside and out:</strong> exterior wash, windows,
          vacuum, and a light interior wipe-down.
        </FeatureItem>
        <FeatureItem data-id="element-1259" data-mp="2gz0d6a0qq096">
          <strong data-id="element-1260" data-mp="2gyi4uf0szvkw">A protective layer:</strong> the hybrid ceramic spray helps
          paint stay shiny.
        </FeatureItem>
        <FeatureItem data-id="element-1261" data-mp="2lr1j7e7beuqr">
          <strong data-id="element-1262" data-mp="2lqib0p7gvkpx">Repels water and dirt:</strong> a protected finish sheds
          water and road grime more easily between washes.
        </FeatureItem>
        <FeatureItem data-id="element-1263" data-mp="2vopgobwb2gcm">
          <strong data-id="element-1264" data-mp="2vp7irp5nfosg">Finished details:</strong> tire dressing for a complete look.
        </FeatureItem>
      </ul>

      <h2 data-id="element-1265" data-mp="30niy2fepqri2">Want a Deeper Clean?</h2>
      <p data-id="element-1266" data-mp="1906xl763308">
        If your interior needs more than a wipe-down, the{' '}
        <Link to="/full-detail" data-id="element-1267" data-mp="16x8qdvv23kf">Full Detail</Link> adds a complete interior
        detail and clay bar treatment. For a lighter maintenance wash on two or
        more cars, see the <Link to="/basic-wash" data-id="element-1268" data-mp="axi65xzst21r">Basic Wash</Link>.
      </p>

      <h2 data-id="element-1269" data-mp="5zysaz70irac">Related Services</h2>
      <RelatedLinks links={[['/full-detail', 'Full Detail'], ['/basic-wash', 'Basic Wash'], ['/services/hybrid-ceramic-spray', 'Hybrid Ceramic Spray'], ['/specials', 'Current Specials']]} data-id="element-1270" data-mp="60rqhbrwo8gv" />
    </ServicePageLayout>;
}